import { stepSchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod";

export const updateAutomation = {
  name: "updateAutomation" as const,
  input: z.object({
    automationId: z.string(),
    name: z.string(),
    steps: z.array(stepSchema),
  }),
  output: z.object({ success: z.boolean() }),
};
